import React, { useCallback, useState } from 'react';
import { UploadIcon } from 'lucide-react';
interface PDFUploaderProps {
  onFileSelect: (file: File) => void;
}
export function PDFUploader({
  onFileSelect
}: PDFUploaderProps) {
  const [isDragging, setIsDragging] = useState(false);
  const handleDrop = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    if (file && file.type === 'application/pdf') {
      onFileSelect(file);
    }
  }, [onFileSelect]);
  const handleDragOver = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setIsDragging(true);
  }, []);
  const handleDragLeave = useCallback(() => {
    setIsDragging(false);
  }, []);
  const handleFileInput = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file && file.type === 'application/pdf') {
      onFileSelect(file);
    }
  }, [onFileSelect]);
  return <div className="flex items-center justify-center min-h-screen w-full bg-zinc-900 p-8" data-id="element-32">
      <div className="max-w-2xl w-full" data-id="element-33">
        <h1 className="text-4xl font-light text-white mb-2 text-center" data-id="element-34">
          Coffee Table Book Viewer
        </h1>
        <p className="text-zinc-400 text-center mb-12" data-id="element-35">
          Upload a PDF to view as an immersive flipbook
        </p>

        <div onDrop={handleDrop} onDragOver={handleDragOver} onDragLeave={handleDragLeave} className={`
            relative border-2 border-dashed rounded-lg p-16 text-center cursor-pointer
            transition-all duration-200
            ${isDragging ? 'border-zinc-400 bg-zinc-800/50' : 'border-zinc-700 bg-zinc-800/20 hover:border-zinc-600 hover:bg-zinc-800/30'}
          `} data-id="element-36">
          <input type="file" accept="application/pdf" onChange={handleFileInput} className="absolute inset-0 w-full h-full opacity-0 cursor-pointer" id="pdf-upload" data-id="element-37" />

          <div className="flex flex-col items-center gap-4" data-id="element-38">
            <div className="w-16 h-16 rounded-full bg-zinc-700/50 flex items-center justify-center" data-id="element-39">
              <UploadIcon className="w-8 h-8 text-zinc-400" data-id="element-40" />
            </div>

            <div data-id="element-41">
              <p className="text-lg text-white mb-1" data-id="element-42">
                Drop your PDF here or click to browse
              </p>
              <p className="text-sm text-zinc-500" data-id="element-43">
                Each page will be displayed as a full spread
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}